import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material';

export type DossierFormsValidationModalProps = {
    onSaveAndPublish: () => void;
    onSaveWithoutPublishing: () => void;
    onCancel: () => void;
};

const DossierFormsValidationModal: React.FunctionComponent<DossierFormsValidationModalProps> =
    function (props) {
        const { onSaveAndPublish, onSaveWithoutPublishing, onCancel } = props;
        const { palette } = useTheme();
        const [saveProcessing, setSaveProcessing] = useState<boolean>(false);
        const [saveAndPublishProcessing, setSaveAndPublishProcessing] = useState<boolean>(false);
        const [disableButtons, setDisableButtons] = useState<boolean>(false);

        const handleCancel = () => {
            setDisableButtons(true);
            onCancel();
        };

        const handleSaveWithoutPublishing = () => {
            setDisableButtons(true);
            setSaveProcessing(true);
            onSaveWithoutPublishing();
        };

        const handleSaveAndPublish = () => {
            setDisableButtons(true);
            setSaveAndPublishProcessing(true);
            onSaveAndPublish();
        };

        const btnSx = {
            padding: '16px 24px',
            minWidth: 'auto',
            lineHeight: '24px',
            backgroundColor: palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            gap: '0 10px',
            '&:hover': {
                backgroundColor: palette.primary.light,
            },
        };

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Typography variant="l2dh6">
                    Souhaitez-vous déposer ce dossier au greffe ?
                </Typography>
                <Typography variant="l2dbodys">
                    Ce dossier peut être déposé au greffe si vous le souhaitez.
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        columnGap: '16px',
                    }}
                >
                    <Button
                        variant="text"
                        sx={{
                            padding: '16px 24px',
                            alignItems: 'center',
                            color: 'primary.dark',
                        }}
                        onClick={() => handleCancel()}
                        disabled={disableButtons}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        sx={btnSx}
                        onClick={() => handleSaveWithoutPublishing()}
                        disabled={disableButtons}
                    >
                        {saveProcessing && (
                            <CircularProgress
                                color="inherit"
                                size="16px"
                            />
                        )}
                        Sauvegarder
                    </Button>
                    <Button
                        variant="contained"
                        sx={btnSx}
                        onClick={() => handleSaveAndPublish()}
                        disabled={disableButtons}
                    >
                        {saveAndPublishProcessing && (
                            <CircularProgress
                                color="inherit"
                                size="16px"
                            />
                        )}
                        Sauvegarder et déposer
                    </Button>
                </Box>
            </Box>
        );
    };

export default DossierFormsValidationModal;
